import { Collapse, IconButton, TableCell } from "@mui/material";
import { MathJaxOutput } from "../../components/mathJax/MathJaxOutput";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { TTableColumn } from "../../types";
import { useState } from "react";

interface TCustomTableCellProps extends Partial<TTableColumn> {
  column: TTableColumn;
  rowNumber: any;
  row: any;
  value: string | number | boolean;
}

function CustomTableCell(props: TCustomTableCellProps) {
  const {
    column,
    row,
    value,
    rowNumber,
    format,
    linkTo,
    expandable,
    expandedFormat,
    stylef,
  } = props;
  const [open, setOpen] = useState(false);

  let transformedStyle = {
    wordWrap: "anywhere",
    verticalAlign: "top",
    fontFamily: "Montserrat",
    fontSize: "16px",
  };
  if (stylef) {
    transformedStyle = {
      ...transformedStyle,
      ...stylef(value?.toString(), row),
    };
  }

  let displayValue: JSX.Element = <span>{value?.toString()}</span>;
  if (format) {
    displayValue = format(value?.toString() || "", row);
  }

  let expandedDisplayValue = value?.toString() || "";
  if (expandedFormat) {
    expandedDisplayValue = expandedFormat(expandedDisplayValue, row);
  }

  const expand = expandable ? (
    <TableCell sx={{ verticalAlign: "top" }}>
      <IconButton
        aria-label="expand row"
        size="small"
        onClick={() => setOpen(!open)}
      >
        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </IconButton>
    </TableCell>
  ) : null;

  return (
    <>
      <TableCell
        sx={transformedStyle}
        //key={column.id + rowNumber.id||rowNumber}
        align={column.align}
        id={rowNumber}
      >
        {
          <>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <MathJaxOutput
                text={
                  typeof linkTo !== "undefined" ? (
                    <a href={linkTo! + value}>{value}</a>
                  ) : (
                    expandedDisplayValue
                  )
                }
              />
            </Collapse>

            {!open ? (
              <MathJaxOutput
                text={
                  typeof linkTo !== "undefined" ? (
                    <a target="_blank" rel="noreferrer" href={linkTo! + value}>
                      {displayValue}
                    </a>
                  ) : (
                    displayValue
                  )
                }
              />
            ) : null}
          </>
        }
      </TableCell>
      {expand}
    </>
  );
}

export default CustomTableCell;
